import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'

export default function AssistantButton({ onClick, isLoading }) {
  const { t } = useTranslation()

  if (isLoading) {
    return <Skeleton height={32} width={100} />
  }

  return (
    <button
      onClick={onClick}
      className='flex h-8 flex-row items-center rounded border border-softGrey px-2 transition-all duration-200 hover:border-buttonSecondaryBlue hover:bg-blue-50 hover:shadow-sm active:scale-95'
    >
      <span className='text-sm font-medium text-buttonSecondaryBlue'>
        {t('discover.assistant.assistant')}
      </span>
      <svg
        width='16'
        height='17'
        viewBox='0 0 16 17'
        fill='none'
        className='ml-0.5'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5 4.5C5.36246 4.5 5.67306 4.75922 5.7379 5.11584L5.99021 6.50355C6.08335 7.01578 6.48422 7.41665 6.99645 7.50979L8.38416 7.7621C8.74078 7.82694 9 8.13754 9 8.5C9 8.86246 8.74078 9.17306 8.38416 9.2379L6.99645 9.49021C6.48422 9.58335 6.08335 9.98422 5.99021 10.4964L5.7379 11.8842C5.67306 12.2408 5.36246 12.5 5 12.5C4.63754 12.5 4.32694 12.2408 4.2621 11.8842L4.00979 10.4964C3.91665 9.98422 3.51578 9.58335 3.00355 9.49021L1.61584 9.2379C1.25922 9.17306 1 8.86246 1 8.5C1 8.13754 1.25922 7.82694 1.61584 7.7621L3.00355 7.50979C3.51578 7.41665 3.91665 7.01578 4.00979 6.50355L4.2621 5.11584C4.32694 4.75922 4.63754 4.5 5 4.5Z'
          fill='#1660F3'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 1.5C12.3349 1.5 12.6291 1.72198 12.7211 2.04396L12.9159 2.7256C13.0345 3.14086 13.3591 3.46546 13.7744 3.5841L14.456 3.77886C14.778 3.87085 15 4.16514 15 4.5C15 4.83486 14.778 5.12915 14.456 5.22114L13.7744 5.4159C13.3591 5.53454 13.0345 5.85914 12.9159 6.2744L12.7211 6.95604C12.6291 7.27802 12.3349 7.5 12 7.5C11.6651 7.5 11.3709 7.27802 11.2789 6.95604L11.0841 6.2744C10.9655 5.85914 10.6409 5.53454 10.2256 5.4159L9.54396 5.22114C9.22198 5.12915 9 4.83486 9 4.5C9 4.16514 9.22198 3.87085 9.54396 3.77886L10.2256 3.5841C10.6409 3.46546 10.9655 3.14086 11.0841 2.7256L11.2789 2.04396C11.3709 1.72198 11.6651 1.5 12 1.5Z'
          fill='#1660F3'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10 11.5C10.3442 11.5 10.6441 11.7342 10.7276 12.0681C10.8143 12.4149 11.0851 12.6857 11.4319 12.7724C11.7658 12.8559 12 13.1558 12 13.5C12 13.8442 11.7658 14.1441 11.4319 14.2276C11.0851 14.3143 10.8143 14.5851 10.7276 14.9319C10.6441 15.2658 10.3442 15.5 10 15.5C9.65585 15.5 9.35586 15.2658 9.27239 14.9319C9.18569 14.5851 8.9149 14.3143 8.5681 14.2276C8.23422 14.1441 8 13.8442 8 13.5C8 13.1558 8.23422 12.8559 8.5681 12.7724C8.9149 12.6857 9.18569 12.4149 9.27239 12.0681C9.35586 11.7342 9.65585 11.5 10 11.5Z'
          fill='#1660F3'
        />
      </svg>
    </button>
  )
}

AssistantButton.propTypes = {
  onClick: PropTypes.func
}
